import styled from "styled-components";

export const UsdcDerivativeSection = styled.div``;
